// Untyped Supabase client for legacy tables not present in the generated types
// (e.g. tenants, tenant_users, work_orders, machines, alerts, mes_events).
// For typed access prefer `@/integrations/supabase/client`.
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});
